export default "__VITE_ASSET__BWL0N$zn__"